export const forum = {
  alerts: {
    createComment: {
      error: 'Something went wrong while creating your comment.',
      success: 'Your comment has been posted.',
    },
    createPost: {
      error: 'Something went wrong while creating your post.',
      success: 'Your post has been created.',
    },
    deleteComment: {
      error: 'Something went wrong while deleting your comment.',
      success: 'Your comment has been deleted.',
    },
    deletePost: {
      error: 'Something went wrong while deleting your post.',
      success: 'Your post has been deleted.',
    },
    editComment: {
      error: 'Something went wrong while editing your comment.',
      success: 'Your comment has been updated.',
    },
    editPost: {
      error: 'Something went wrong while editing your post.',
      success: 'Your post has been updated.',
    },
  },
  breadcrumb: {
    guidelines: 'Guidelines',
    root: 'Forum',
    saved: 'Bookmarked posts',
    self: 'My posts',
  },
  comments: {
    communityProfileRequired: {
      action: 'Make profile public',
      description: 'To comment, you need a public Community profile.',
    },
    error: {
      title: 'Error loading the comments.',
    },
    titleUnknown: 'Comments',
    title_one: '{{count}} comment',
    title_other: '{{count}} comments',
  },
  createComment: {
    actions: {
      comment: 'Comment',
    },
  },
  createPost: {
    actions: {
      post: 'Post',
    },
    disclaimer: 'Could you read the <guidelinesLink>Community guidelines</guidelinesLink> before you post?',
    fields: {
      content: {
        label: 'Content',
      },
      tag: {
        description: 'Choose the tag that best fits your post.',
        label: 'Tag',
      },
      title: {
        label: 'Title',
      },
    },
    title: 'Create post',
  },
  deleteComment: {
    actions: {
      confirm: 'Delete comment',
    },
    description: 'Are you sure you want to delete your comment?',
    title: 'Delete comment',
  },
  deletePost: {
    actions: {
      confirm: 'Delete post',
      confirmUnable: 'I get it',
    },
    description: 'Are you sure you want to delete your post “{{title}}”?',
    descriptionUnable:
      'You can’t delete your post because other freelancers have commented on it.<br/>Would you still like to delete your post? Contact <emailLink href="mailto:community@creativeshelter.be">community@creativeshelter.be</emailLink> and we’ll take care of it.',
    title: 'Delete post',
    titleUnable: 'Unable to delete',
  },
  guidelines: {
    content:
      '<introduction>The Community ground rules. Not because it’s a game you can win, but you might checkmate someone with a fair remark. Kindly though, wrapped in cotton wool and bubble wrap.</introduction>\n\n<subtitle>Be nice. Can we agree on that?</subtitle>\n\n<paragraph>The forum was made for you and all other Shelterers, but we keep an eye on things too. Foul language, racist remarks, homophobic behavior … there’s no place for that.</paragraph>\n\n<paragraph>Be nice to each other, that’s the message.</paragraph>\n\n<subtitle>There are no stupid questions or answers</subtitle>\n\n<paragraph>All Shelterers can respond, give advice or share their opinion on questions asked in the forum. So you might not agree with everything, or a mistake might sneak into an answer. The same applies there: be nice to each other. Or as the song goes: be tolerant!</paragraph>\n\n<paragraph>A legal question, tips about accounting or copyright? Then Creative Shelter itself might respond.</paragraph>\n\n<subtitle>Sensitive information? That stays within the Community walls.<br />What happens at the forum, stays at the forum.</subtitle>\n\n<paragraph>Sensitive situations, hourly rates, someone’s grandma’s address … you don’t pass them on. The forum is exactly the place to chat and spar about topics like these in a safe environment, without them suddenly doing the rounds. For gossip, head to your group chat with your friends.</paragraph>',
    header: {
      title: 'Community guidelines',
    },
  },
  moderatorDialog: {
    introduction:
      'I’m keeping an eye on things! Just making sure everyone stays nice to each other and this stays a cozy place. Questions or compliments? Fire away!',
  },
  overview: {
    error: {
      title: 'Error loading the forum.',
    },
    header: {
      title: 'Community forum',
    },
    postPreview: {
      pinned: 'Pinned',
    },
    savedPosts: {
      empty: 'You haven’t bookmarked any posts yet.',
      error: {
        title: 'Error loading your bookmarked posts.',
      },
      title: 'Bookmarked posts',
    },
    selfPosts: {
      empty: 'You haven’t created a post yet.',
      error: {
        title: 'Error loading your posts.',
      },
      title: 'Your posts',
    },
    timeline: {
      empty: 'Nothing has been posted yet.',
      error: {
        title: 'Error loading your home page.',
      },
      title: 'Home page',
    },
  },
  post: {
    card: {
      actions: {
        comment: 'Comment',
        comments: '{{count}} comments',
        like: 'Like ({{count}} likes)',
      },
      edited: 'edited',
    },
    error: {
      title: 'Error loading the post.',
    },
    systemMessages: {
      CommentDeletedByModerator:
        '{{moderator, ucfirst}} deleted this comment because it doesn’t meet our <guidelinesLink>guidelines</guidelinesLink>.',
      CommentDeletedByUser: 'This comment has been deleted.',
      LockedByModerator: '{{moderator, ucfirst}} has locked this post. Commenting is no longer possible.',
      MovedByModerator: '{{moderator, ucfirst}} moved this post from <bold>{{oldTag}}</bold> to <bold>{{newTag}}</bold>.',
      unknownModerator: 'A moderator',
    },
  },
  sidebar: {
    sections: {
      favoriteTags: 'Favorite tags',
      quickLinks: 'Useful links',
      tags: 'All tags',
    },
    toggleFavoriteTag: 'Mark {{tag}} as favorite',
  },
  tags: {
    Announcements: {
      name: 'Announcements',
    },
    Audiovisual: {
      name: 'Audiovisual',
    },
    DigitalDesign: {
      name: 'Digital design',
    },
    FreelanceLife: {
      name: 'Freelance life',
    },
    ItDevelopment: {
      name: 'IT development',
    },
    LanguageAndCommunication: {
      name: 'Language and communication',
    },
    OnlineContentCreation: {
      name: 'Online content creation and storytelling',
    },
    PerformingArtists: {
      name: 'Performing artist',
    },
    Photography: {
      name: 'Photography',
    },
    VisualCommunication: {
      name: 'Visual communication',
    },
  },
};
